import { render } from "./colorBySelector.vue?vue&type=template&id=1348a068&ts=true"
import script from "./colorBySelector.vue?vue&type=script&lang=ts"
export * from "./colorBySelector.vue?vue&type=script&lang=ts"

import "./colorBySelector.vue?vue&type=style&index=0&id=1348a068&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__